/**
 * Google Maps Map ID — identifier for a custom map style.
 *
 * Apply as the `mapId` option when initializing the JavaScript map to use a
 * style configured in Google Cloud Console.
 *
 */
export const GOOGLE_MAP_ID = '46b6aa5f650c9fa7175e5400'
